import { create } from "zustand";

export const usePlayersStore = create((set, get) => ({
  byLogin: new Map(),
  upsert: (player) =>
    set((state) => {
      const newMap = new Map(state.byLogin);
      newMap.set(player.login, player);
      return { byLogin: newMap };
    }),
  getOne: (login) => get().byLogin.get(login),
}));
